import { Card, Skeleton, Space } from "antd";

const PlanCardSkeleton = () => {
  return (
    <Card
      style={{
        maxWidth: "100%",
        margin: "0 auto",
        borderRadius: 8,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        padding: 0,
        borderTop: ".5rem solid #00B7F1",
      }}
      bodyStyle={{ padding: 0 }}
    >
      {/* Blue top bar */}
      <div
        style={{
          backgroundColor: "#E3F3FF",
          padding: "16px 20px",
          position: "relative",
          marginBottom: 16,
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
          <div>
            <Skeleton.Input
              active
              style={{ width: 180, height: 20, marginBottom: 12 }}
            />

            <div style={{ display: "flex", flexDirection: "column" }}>
              <Skeleton.Input
                active
                style={{ width: 70, height: 36, marginBottom: 4 }}
              />
              <Skeleton.Input active style={{ width: 80, height: 16 }} />
            </div>
          </div>

          {/* Flame icon in top right */}
          <Skeleton.Avatar
            active
            size={40}
            shape="circle"
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.2)",
            }}
          />
        </div>
      </div>

      {/* Content area */}
      <div style={{ padding: "0 20px 20px", overflow: "hidden" }}>
        <Space direction="vertical" style={{ width: "100%", marginBottom: 20 }}>
          <div
            style={{ display: "flex", alignItems: "center", marginBottom: 12 }}
          >
            <Skeleton.Avatar
              active
              size={16}
              shape="circle"
              style={{ marginRight: 12 }}
            />
            <Skeleton.Input active style={{ width: 150, height: 16 }} />
          </div>

          <div
            style={{ display: "flex", alignItems: "center", marginBottom: 12 }}
          >
            <Skeleton.Avatar
              active
              size={16}
              shape="circle"
              style={{ marginRight: 12 }}
            />
            <Skeleton.Input active style={{ width: 100, height: 16 }} />
          </div>

          <div
            style={{ display: "flex", alignItems: "center", marginBottom: 12 }}
          >
            <Skeleton.Avatar
              active
              size={16}
              shape="circle"
              style={{ marginRight: 12 }}
            />
            <Skeleton.Input active style={{ width: 130, height: 16 }} />
          </div>

          <div style={{ display: "flex", alignItems: "center" }}>
            <Skeleton.Avatar
              active
              size={16}
              shape="circle"
              style={{ marginRight: 12 }}
            />
            <Skeleton.Input active style={{ width: 200, height: 16 }} />
          </div>
        </Space>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            marginTop: 16,
          }}
        >
          <Skeleton.Button active style={{ width: 130, height: 36 }} />
          <Skeleton.Button
            active
            style={{
              width: 130,
              height: 36,
              borderRadius: 4,
              backgroundColor: "#f5f5f5",
            }}
          />
        </div>
      </div>
    </Card>
  );
};

export default PlanCardSkeleton;
